import type { LayerName, LayerRegistryEntry, MeasureId } from "./types";

function ramp(prefix: string): LayerRegistryEntry["rampTokens"] {
  return [
    `--signal-${prefix}-0`,
    `--signal-${prefix}-1`,
    `--signal-${prefix}-2`,
    `--signal-${prefix}-3`,
    `--signal-${prefix}-4`,
    `--signal-${prefix}-5`,
    `--signal-${prefix}-6`,
  ] as const;
}

export const LAYER_REGISTRY: Record<LayerName, LayerRegistryEntry> = {
  income: {
    name: "income",
    group: "income_wealth",
    measures: ["income.median_after_tax"] as const,
    defaultMeasure: "income.median_after_tax",
    rampTokens: ramp("income"),
    copyKey: "layers.income",
  },
  age: {
    name: "age",
    group: "demographics",
    measures: ["age.under_35", "age.35_64", "age.65_plus"] as const,
    defaultMeasure: "age.under_35",
    rampTokens: ramp("age"),
    copyKey: "layers.age",
  },
  education: {
    name: "education",
    group: "demographics",
    measures: ["education.university_degree"] as const,
    defaultMeasure: "education.university_degree",
    rampTokens: ramp("education"),
    copyKey: "layers.education",
  },
  ethnicity: {
    name: "ethnicity",
    group: "demographics",
    measures: ["ethnicity.visible_minority"] as const,
    defaultMeasure: "ethnicity.visible_minority",
    rampTokens: ramp("ethnicity"),
    copyKey: "layers.ethnicity",
  },
  language: {
    name: "language",
    group: "demographics",
    measures: [
      "language.french_only",
      "language.english_only",
      "language.bilingual_fr_en",
      "language.other",
    ] as const,
    defaultMeasure: "language.french_only",
    rampTokens: ramp("language"),
    copyKey: "layers.language",
  },
};

export const LAYER_NAMES = Object.keys(LAYER_REGISTRY) as readonly LayerName[];

export function isLayerName(x: string): x is LayerName {
  return x in LAYER_REGISTRY;
}

export function measureLayer(m: MeasureId): LayerName {
  return m.split(".")[0] as LayerName;
}

export function isMeasureOfLayer(m: string, layer: LayerName): m is MeasureId {
  const entry = LAYER_REGISTRY[layer];
  return (entry.measures as readonly string[]).includes(m);
}
